import React from 'react';
export default function ProfileSliderFormCard({linkUrl, linkIcon, linkTitle}) {
    return (
        <div className="form-card-div"
             onClick={() => window.location.href = linkUrl}>
            <div className="form-card">
                <div className="form-card-icon">
                    <img alt={linkTitle} src={linkIcon}/>
                </div>
                <div className="form-card-title">
                    {linkTitle}
                </div>
            </div>
        </div>
    );
}
